import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
   selector: 'samweb-drag-container',
   templateUrl: './drag-container.component.html',
   styleUrls: ['./drag-container.component.scss'],
})
export class DragContainerComponent {
   @Input()
   public zoneId: string;

   @Input()
   public item: any;

   @Input()
   public availableDropZones: string[];

   @Input()
   public disabled = false;

   @Output()
   public dragStart = new EventEmitter<any>();

   @Output()
   public dragEnd = new EventEmitter<any>();

   public isDragged$ = new BehaviorSubject<boolean>(false);

   dragStarted(draggedItem) {
      this.isDragged$.next(true);
      this.dragStart.emit(draggedItem);
   }

   dragEnded(draggedItem) {
      this.isDragged$.next(false);
      this.dragEnd.emit(draggedItem);
   }
}
